import { createAction } from "redux-actions";

export const CATEGORY_LIST = "CATEGORY_LIST";
export const categoryList = createAction(CATEGORY_LIST);

export const CATEGORY_LIST_FOR_COUPON = "CATEGORY_LIST_FOR_COUPON";
export const categoryListForCoupon = createAction(CATEGORY_LIST_FOR_COUPON);
